import actions from '../Actions/actions';

const initialState = {
    fetching: false,
    fetched: false,
    error: null,
    statusCode: null,

    birthDate: '', //"1983-11-24T00:00:00",
    city: '', //"Jönköping",
    coAddress: null,
    coInsuredId: null, //4651306,
    country: null,
    firstName: '', //"Medförsäkrad",
    foAddress: null,
    lastName: '', //"Medefternamn",
    personalIdentityNumber: '', //"198311241437",
    streetAddress: '', //"Björkvägen 66",
    zipCode: null, //55313
};

export default function coInsuredInfo(state = initialState, action = {}) {
    let returnState = { ...state };

    switch (action.type) {
        case actions.COINSURED_INFO_FETCHING_SET:
            returnState = {
                ...state,
                fetching: !!action.payload
            };
            break;
        case actions.COINSURED_INFO_SET:
            returnState = {
                ...state,
                ...action.payload
            };
            break;
    }

    return returnState;
}